var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Mastercard_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 40"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Mastercard_svg__st5{display:none}.Mastercard_svg__st6{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#1334cb}")), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 39.5c-1.5 0-2.7-1.3-2.7-2.8V3.3C.5 1.7 1.7.5 3.2.5h57.6c1.5 0 2.7 1.3 2.7 2.8v33.3c0 1.6-1.2 2.8-2.7 2.8H3.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8 1C62 1 63 2 63 3.3v33.3c0 1.3-1 2.3-2.2 2.3H3.2C2 39 1 38 1 36.7V3.3C1 2 2 1 3.2 1zm0-1H3.2C1.4 0 0 1.5 0 3.3v33.3C0 38.5 1.4 40 3.2 40h57.6c1.8 0 3.2-1.5 3.2-3.3V3.3C64 1.5 62.6 0 60.8 0",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 9.8h11.3v20.5H26.3z",
    style: {
      fill: "#ff5a00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mastercard_svg__XMLID_1_",
    d: "M27 20c0-4.2 2-7.8 5-10.2C29.8 8.2 27 7 24 7c-7.2 0-13 5.8-13 13s5.8 13 13 13c3 0 5.8-1 8-2.8-3-2.4-5-6-5-10.2",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 20c0 7.2-5.8 13-13 13-3 0-5.8-1-8-2.8 3-2.3 5-6.2 5-10.2s-2-7.8-5-10.2C34.2 8.2 37 7 40 7c7.2 0 13 5.8 13 13",
    style: {
      fill: "#f79e1b"
    }
  }));
};
export default SvgMastercard;